import { Download, Info } from "lucide-react";
import { useSite } from "../lib/site";
import { API } from "../lib/api";
import { useT } from "../lib/i18n";

export function ToshniwalProfile({ compact }) {
  const { show_toshniwal_profile } = useSite();
  const { tl } = useT();
  if (!show_toshniwal_profile) return null;
  return (
    <div className={`grid ${compact ? "md:grid-cols-[200px_1fr]" : "md:grid-cols-[280px_1fr]"} gap-8 items-start bg-white border rounded-2xl p-6 sm:p-8`} data-testid="toshniwal-profile">
      <img src="/brand/toshniwal-brothers-logo-640.webp" srcSet="/brand/toshniwal-brothers-logo-320.webp 320w, /brand/toshniwal-brothers-logo-640.webp 640w" sizes="(max-width: 768px) 60vw, 280px"
        alt={tl("Toshniwal Brothers logo — gold and navy building emblem with red Toshniwal lettering")} width="640" height="640" loading="lazy" className="w-48 md:w-full h-auto rounded-xl border" />
      <div>
        <p className="eyebrow">{tl("Business profile")}</p>
        <h3 className="text-2xl font-bold mt-2">{tl("Toshniwal Brothers")}</h3>
        <p className="text-slate-700 mt-3">{tl("Toshniwal Brothers is the Kota, Rajasthan-based business proposing this solar partner network. Its tagline is “Partnering for a brighter, sustainable tomorrow”.")}</p>
        <p className="text-sm text-slate-600 mt-3 flex gap-2"><Info className="h-4 w-4 mt-0.5 shrink-0" />{tl("Its legal role as programme operator and contracting party, and its registration details, will be published only after they are verified.")}</p>
        {!compact && <a href="/brand/original/toshniwal-brothers-strengths-benefits.jpeg" download className="hidden md:inline-flex items-center gap-2 mt-5 text-sm font-semibold text-amber-800 underline" data-testid="download-benefits-graphic"><Download className="h-4 w-4" />{tl("Download the Toshniwal Brothers strengths graphic (JPEG)")}</a>}
      </div>
    </div>
  );
}

export function PmSolarSection() {
  const { show_pm_solar } = useSite();
  const { tl } = useT();
  if (!show_pm_solar) return null;
  return (
    <div className="grid md:grid-cols-[220px_1fr] gap-8 items-start bg-white border rounded-2xl p-6 sm:p-8" data-testid="pm-solar-section">
      <img src="/brand/pm-solar-logo-320.webp" srcSet="/brand/pm-solar-logo-320.webp 320w, /brand/pm-solar-logo-640.webp 640w" sizes="220px" width="320" height="320" loading="lazy"
        alt={tl("PM Solar logo — orange and green gear around a sun and solar panel, with the line Clean Energy, Brighter Tomorrow")} className="w-40 md:w-full h-auto rounded-xl border" />
      <div>
        <p className="eyebrow">{tl("Solar awareness")}</p>
        <h3 className="text-2xl font-bold mt-2">{tl("PM Solar — solar awareness resources")}</h3>
        <p className="text-slate-700 mt-3">{tl("PM Solar publishes awareness material about rooftop solar and the PM Surya Ghar scheme at")} <a href="https://pmsolar.org.in/" target="_blank" rel="noopener noreferrer" className="underline text-amber-800">pmsolar.org.in</a>.</p>
        <p className="text-sm text-slate-600 mt-3 flex gap-2"><Info className="h-4 w-4 mt-0.5 shrink-0" />{tl("PM Solar is shown here for education only. It is not the operator, contracting party, installer or payment recipient of this partner programme, and it is not a government department. For official scheme rules, use pmsuryaghar.gov.in.")}</p>
      </div>
    </div>
  );
}

export function ApnSection() {
  const { apn_logo_enabled, apn_brand_text } = useSite();
  const { tl } = useT();
  if (!apn_logo_enabled) return null;
  return (
    <div className="grid md:grid-cols-[220px_1fr] gap-8 items-start bg-white border rounded-2xl p-6 sm:p-8" data-testid="apn-section">
      <img src={`${API}/public/brand/apn-logo`} width="320" height="320" loading="lazy" alt={tl("APN Solar logo")} className="w-40 md:w-full h-auto rounded-xl border" />
      <div><p className="eyebrow">{tl("Brand relationship")}</p><p className="text-slate-700 mt-3">{apn_brand_text}</p></div>
    </div>
  );
}
